import CourseLayout from './layouts/CourseLayout'
import LiveLayout from './layouts/LiveLayout'
import Course from './pages/Course'
import Lecture from './pages/Lecture'
import Exam from './pages/Exam'
import Login from './pages/Login'
import Register from './pages/Register'

export default [
  {
    path: '/:course/live',
    alias: '/home/courses/:course/live/preview',
    component: LiveLayout,
    name: 'live',
  },
  {
    path: '/:course/watch',
    alias: '/home/courses/:course/preview',
    component: CourseLayout,
    children: [
      {
        path: '',
        name: 'course',
        component: Course,
      },
      {
        path: 'login',
        name: 'login',
        component: Login,
      },
      {
        path: 'register',
        name: 'register',
        component: Register,
      },
      {
        path: ':lecture',
        name: 'lecture',
        component: Lecture,
      },
      {
        path: 'exam/:exam',
        name: 'exam',
        component: Exam,
      },
    ],
  },

]
